import { Injectable, NgZone } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { parseValidString } from '../utils';
@Injectable({
  providedIn: 'root',
})
export class GenesysBridgeService {
  public windowEvent$!: Observable<any>;

  public interactionSubscription$: Observable<any>;
  public userActionSubscription$: Observable<any>;
  public notificationSubscription$: Observable<any>;

  public userStatus$: Observable<any>;

  constructor(private ngZone: NgZone) {
    this.windowEvent$ = this.createWindowEventObservable();

    this.interactionSubscription$ = this.createFilteredObservable(
      'interactionSubscription'
    );
    this.userActionSubscription$ = this.createFilteredObservable(
      'userActionSubscription'
    );
    this.notificationSubscription$ = this.createFilteredObservable(
      'notificationSubscription'
    );

    this.userStatus$ = this.userActionSubscription$.pipe(
      filter((e) => e.data.category === 'status')
    );
  }

  private createWindowEventObservable(): Observable<any> {
    return new Observable((observer) => {
      this.ngZone.runOutsideAngular(() => {
        const messageHandler = (event: MessageEvent) =>
          observer.next(event.data);
        window.addEventListener('message', messageHandler);
        return () => window.removeEventListener('message', messageHandler);
      });
    }).pipe(
      filter((data: any) => parseValidString(data)),
      map((data) => JSON.parse(data))
    );
  }

  private createFilteredObservable(type: string): Observable<any> {
    return this.windowEvent$.pipe(filter((e) => e.type === type));
  }

  private postMessageToSoftphone(type: string, data: any): void {
    const iframe = document.getElementById('softphone') as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(JSON.stringify({ type, data }), '*');
    }
  }

  public callInteraction(action: string, interactionId: string): void {
    const payload = { action, id: interactionId };
    this.postMessageToSoftphone('updateInteractionState', payload);
  }

  public clickToDial(type: string, number: string, queueId?: string): void {
    const payload = { type, number, queueId, autoPlace: true };
    this.postMessageToSoftphone('clickToDial', payload);
  }

  public addAssociation(payload: any): void {
    this.postMessageToSoftphone('addAssociation', payload);
  }

  public addAttribute(payload: any): void {
    this.postMessageToSoftphone('addAttribute', payload);
  }

  public addTransferContext(payload: any): void {
    this.postMessageToSoftphone('addTransferContext', payload);
  }

  public sendContactSearch(payload: any): void {
    this.postMessageToSoftphone('sendContactSearch', payload);
  }

  public updateUserStatus(statusId: string): void {
    this.postMessageToSoftphone('updateUserStatus', { id: statusId });
  }

  public updateInteractionState(action: string, interactionId: string): void {
    const payload = { action, id: interactionId };
    this.postMessageToSoftphone('updateInteractionState', payload);
  }

  public updateAudioConfiguration(config: {
    call: boolean;
    chat: boolean;
    email: boolean;
    callback: boolean;
    message: boolean;
    voicemail: boolean;
  }): void {
    this.postMessageToSoftphone('updateAudioConfiguration', config);
  }

  public setView(viewName: string): void {
    const payload = { type: 'main', view: { name: viewName } };
    this.postMessageToSoftphone('setView', payload);
  }

  public sendCustomNotification(payload: {
    message: string;
    type: string;
    timeout: number;
  }): void {
    this.postMessageToSoftphone('sendCustomNotification', payload);
  }
}
